module.exports = __webpack_public_path__ + "img/ic-manual-point.0c68f332.svg";